import React from "react";
import { reportClientError } from "../utils/clientObservability";
import RuntimeConfigurationFailure from "./RuntimeConfigurationFailure";

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false, incidentId: null, error: null };
  }

  static getDerivedStateFromError(error) {
    return { failed: true, incidentId: `client-${Date.now().toString(36)}`, error };
  }

  componentDidCatch(error, info) {
    reportClientError(error, {
      operation: "react_render",
      incidentId: this.state.incidentId,
      componentStack: info?.componentStack || "",
    });
  }

  render() {
    if (!this.state.failed) return this.props.children;
    if (/runtime configuration|firebase configuration|unsafe firebase/i.test(this.state.error?.message || "")) {
      return <RuntimeConfigurationFailure error={this.state.error} />;
    }
    return (
      <main role="alert" aria-live="assertive">
        <h1>NAVIG8 could not display this page</h1>
        <p>Your work may still be saved. Refresh once; if the problem continues, share this incident reference with support.</p>
        <p><code>{this.state.incidentId}</code></p>
        <button type="button" onClick={() => window.location.reload()}>Refresh page</button>
      </main>
    );
  }
}
